import React from 'react';
import { useNavigate } from 'react-router-dom';

const TermsPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#F1F5F9', fontFamily: "'Zen Kaku Gothic New', sans-serif" }}>
      {/* ヘッダー */}
      <header
        style={{
          backgroundColor: 'rgba(255, 255, 255, 0.92)',
          backdropFilter: 'blur(14px)',
          borderBottom: '1px solid rgba(37, 99, 235, 0.1)',
          padding: '1rem 2rem',
        }}
      >
        <div
          style={{
            maxWidth: '1200px',
            margin: '0 auto',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <div
            onClick={() => navigate('/')}
            style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer' }}
          >
            <span style={{ fontSize: '0.78rem', fontWeight: 700, color: '#64748B', letterSpacing: '0.06em' }}>
              勤怠管理
            </span>
            <span
              style={{
                fontFamily: "'Outfit', sans-serif",
                fontWeight: 800,
                fontSize: '1.45rem',
                color: '#2563EB',
                letterSpacing: '-0.03em',
              }}
            >
              キン<b style={{ color: '#1A2E4A', fontWeight: 800 }}>ログ</b>
            </span>
          </div>
          <button
            onClick={() => navigate('/')}
            style={{
              padding: '9px 22px',
              backgroundColor: 'transparent',
              border: '2px solid #2563EB',
              borderRadius: '50px',
              color: '#2563EB',
              cursor: 'pointer',
              fontSize: '0.88rem',
              fontWeight: 600,
              transition: 'all 0.2s',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#2563EB';
              e.currentTarget.style.color = '#fff';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'transparent';
              e.currentTarget.style.color = '#2563EB';
            }}
          >
            トップページに戻る
          </button>
        </div>
      </header>

      {/* コンテンツ */}
      <div style={{ maxWidth: '800px', margin: '0 auto', padding: '3rem 2rem' }}>
        <h1 style={{ fontSize: '2rem', fontWeight: 900, marginBottom: '2rem', color: '#1E293B' }}>
          利用規約
        </h1>

        <div style={{ backgroundColor: '#fff', padding: '2rem', borderRadius: '22px', lineHeight: 1.8, boxShadow: '0 4px 20px rgba(0, 0, 0, 0.06)' }}>
          <p style={{ color: '#64748B', marginBottom: '2rem' }}>
            この利用規約（以下「本規約」といいます）は、勤怠管理
            キンログ（以下「本サービス」といいます）の利用条件を定めるものです。ご利用の際には、本規約の全文をお読みいただき、同意いただく必要があります。
          </p>

          <section style={{ marginBottom: '2.5rem' }}>
            <h2 style={{ fontSize: '1.3rem', fontWeight: 700, marginBottom: '1rem', color: '#1E293B' }}>
              第1条（適用）
            </h2>
            <ol style={{ paddingLeft: '1.5rem', color: '#64748B' }}>
              <li>
                本規約は、本サービスの提供条件及び本サービスの利用に関する当社とユーザーとの間の権利義務関係を定めることを目的とし、ユーザーと当社との間の本サービスの利用に関わる一切の関係に適用されます。
              </li>
              <li>
                本規約の内容と、本規約外における本サービスの説明等とが異なる場合は、本規約の規定が優先して適用されるものとします。
              </li>
            </ol>
          </section>

          <section style={{ marginBottom: '2.5rem' }}>
            <h2 style={{ fontSize: '1.3rem', fontWeight: 700, marginBottom: '1rem', color: '#1E293B' }}>
              第2条（定義）
            </h2>
            <p style={{ color: '#64748B', marginBottom: '0.5rem' }}>本規約において使用する以下の用語は、各々以下に定める意味を有するものとします。</p>
            <ol style={{ paddingLeft: '1.5rem', color: '#64748B' }}>
              <li>「サービス利用契約」とは、本規約を契約条件として当社とユーザーの間で締結される、本サービスの利用契約を意味します。</li>
              <li>「ユーザー」とは、本サービスを利用するすべての企業・団体・個人を意味します。</li>
              <li>
                「登録情報」とは、ユーザーが本サービスの利用にあたり当社に提供した企業名、メールアドレス、その他の情報を意味します。
              </li>
            </ol>
          </section>

          <section style={{ marginBottom: '2.5rem' }}>
            <h2 style={{ fontSize: '1.3rem', fontWeight: 700, marginBottom: '1rem', color: '#1E293B' }}>
              第3条（登録）
            </h2>
            <ol style={{ paddingLeft: '1.5rem', color: '#64748B' }}>
              <li>本サービスの利用を希望する者は、本規約を遵守することに同意し、当社の定める方法によって利用登録を申請するものとします。</li>
              <li>
                当社は、登録申請者が以下の各号のいずれかの事由に該当する場合は、登録及び再登録を拒否することがあります。
                <ul style={{ paddingLeft: '1.5rem', marginTop: '0.5rem' }}>
                  <li>当社に提供した登録情報の全部または一部につき虚偽、誤記または記載漏れがあった場合</li>
                  <li>過去に本規約に違反したことがある場合</li>
                  <li>その他、登録を適当でないと当社が判断した場合</li>
                </ul>
              </li>
            </ol>
          </section>

          <section style={{ marginBottom: '2.5rem' }}>
            <h2 style={{ fontSize: '1.3rem', fontWeight: 700, marginBottom: '1rem', color: '#1E293B' }}>
              第4条（アカウント管理）
            </h2>
            <ol style={{ paddingLeft: '1.5rem', color: '#64748B' }}>
              <li>
                ユーザーは、自己の責任において、本サービスに関するアカウント情報を適切に管理及び保管するものとし、これを第三者に利用させ、または貸与、譲渡、名義変更、売買等をしてはならないものとします。
              </li>
              <li>アカウント情報の管理不十分、使用上の過誤、第三者の使用等による損害の責任はユーザーが負うものとします。</li>
            </ol>
          </section>

          <section style={{ marginBottom: '2.5rem' }}>
            <h2 style={{ fontSize: '1.3rem', fontWeight: 700, marginBottom: '1rem', color: '#1E293B' }}>
              第5条（禁止事項）
            </h2>
            <p style={{ color: '#64748B', marginBottom: '0.5rem' }}>
              ユーザーは、本サービスの利用にあたり、以下の各号のいずれかに該当する行為または該当すると当社が判断する行為をしてはなりません。
            </p>
            <ol style={{ paddingLeft: '1.5rem', color: '#64748B' }}>
              <li>法令に違反する行為または犯罪行為に関連する行為</li>
              <li>当社、本サービスの他のユーザー、または第三者に対する詐欺または脅迫行為</li>
              <li>公序良俗に反する行為</li>
              <li>当社、本サービスの他のユーザー、または第三者の知的財産権、肖像権、プライバシーの権利、名誉、その他の権利または利益を侵害する行為</li>
              <li>本サービスのネットワークまたはシステム等に過度な負荷をかける行為</li>
              <li>本サービスの運営を妨害するおそれのある行為</li>
              <li>当社のネットワークまたはシステム等に不正にアクセスし、または不正なアクセスを試みる行為</li>
              <li>第三者に成りすまして本サービスを利用する行為</li>
              <li>本サービスの他のユーザーのアカウントを利用する行為</li>
              <li>反社会的勢力等への利益供与</li>
              <li>その他、当社が不適切と判断する行為</li>
            </ol>
          </section>

          <section style={{ marginBottom: '2.5rem' }}>
            <h2 style={{ fontSize: '1.3rem', fontWeight: 700, marginBottom: '1rem', color: '#1E293B' }}>
              第6条（本サービスの停止等）
            </h2>
            <ol style={{ paddingLeft: '1.5rem', color: '#64748B' }}>
              <li>
                当社は、以下のいずれかに該当する場合には、ユーザーに事前に通知することなく、本サービスの全部または一部の提供を停止または中断することができるものとします。
                <ul style={{ paddingLeft: '1.5rem', marginTop: '0.5rem' }}>
                  <li>本サービスに係るコンピューター・システムの点検または保守作業を緊急に行う場合</li>
                  <li>コンピューター、通信回線等の障害、誤操作、過度なアクセスの集中、不正アクセス、ハッキング等により本サービスの運営ができなくなった場合</li>
                  <li>地震、落雷、火災、風水害、停電、天災地変などの不可抗力により本サービスの運営ができなくなった場合</li>
                  <li>その他、当社が停止または中断を必要と判断した場合</li>
                </ul>
              </li>
              <li>当社は、本条に基づき当社が行った措置に基づきユーザーに生じた損害について一切の責任を負いません。</li>
            </ol>
          </section>

          <section style={{ marginBottom: '2.5rem' }}>
            <h2 style={{ fontSize: '1.3rem', fontWeight: 700, marginBottom: '1rem', color: '#1E293B' }}>
              第7条（料金及び支払方法）
            </h2>
            <ol style={{ paddingLeft: '1.5rem', color: '#64748B' }}>
              <li>本サービスの利用料金は、当社が別途定める料金表に従うものとします。</li>
              <li>ユーザーは、利用料金を、当社が指定する方法により支払うものとします。</li>
              <li>ユーザーが利用料金の支払を遅滞した場合、ユーザーは年14.6%の割合による遅延損害金を当社に支払うものとします。</li>
              <li>無料トライアル期間終了後、ユーザーが本サービスの利用を継続する場合、自動的に有料プランへ移行するものとします。</li>
            </ol>
          </section>

          <section style={{ marginBottom: '2.5rem' }}>
            <h2 style={{ fontSize: '1.3rem', fontWeight: 700, marginBottom: '1rem', color: '#1E293B' }}>
              第8条（解約）
            </h2>
            <ol style={{ paddingLeft: '1.5rem', color: '#64748B' }}>
              <li>ユーザーは、当社所定の方法により、いつでも本サービスの利用契約を解約することができます。</li>
              <li>解約の申し出があった場合、当該月の末日をもって解約となります。</li>
              <li>解約後の利用料金の返金は行いません。</li>
              <li>
                解約後、当社は、解約日から30日間、ユーザーが登録したデータを保持します。ユーザーは、当該期間中に限り、本サービスの機能によりデータをダウンロードすることができます。
              </li>
              <li>
                前項の期間経過後、当社はユーザーの登録データを削除します。<strong>削除されたデータを復元することはできません。</strong>
              </li>
              <li>
                無料トライアル期間が終了し、ユーザーが有料プランへ移行しなかった場合も、前2項と同様に取り扱います。
              </li>
              <li>
                ユーザーは、法令上の保存義務（労働基準法に基づく賃金台帳・出勤簿等の保存を含みます。）を自ら負うことを確認し、必要なデータを前2項に定める期間内に取得するものとします。
              </li>
            </ol>
          </section>

          <section style={{ marginBottom: '2.5rem' }}>
            <h2 style={{ fontSize: '1.3rem', fontWeight: 700, marginBottom: '1rem', color: '#1E293B' }}>
              第9条（保証の否認及び免責）
            </h2>
            <ol style={{ paddingLeft: '1.5rem', color: '#64748B' }}>
              <li>
                当社は、本サービスがユーザーの特定の目的に適合すること、期待する機能・商品的価値・正確性・有用性を有すること、ユーザーによる本サービスの利用がユーザーに適用のある法令または業界団体の内部規則等に適合すること、継続的に利用できること、及び不具合が生じないことについて、明示又は黙示を問わず何ら保証するものではありません。
              </li>
              <li>
                当社は、本サービスに関してユーザーが被った損害につき、過去12ヶ月間にユーザーが当社に支払った対価の金額を超えて賠償する責任を負わないものとします。
              </li>
            </ol>
          </section>

          <section style={{ marginBottom: '2.5rem' }}>
            <h2 style={{ fontSize: '1.3rem', fontWeight: 700, marginBottom: '1rem', color: '#1E293B' }}>
              第10条（知的財産権）
            </h2>
            <ol style={{ paddingLeft: '1.5rem', color: '#64748B' }}>
              <li>
                本サービスに関する知的財産権は全て当社または当社にライセンスを許諾している者に帰属しており、本規約に基づく本サービスの利用許諾は、本サービスに関する当社または当社にライセンスを許諾している者の知的財産権の使用許諾を意味するものではありません。
              </li>
            </ol>
          </section>

          <section style={{ marginBottom: '2.5rem' }}>
            <h2 style={{ fontSize: '1.3rem', fontWeight: 700, marginBottom: '1rem', color: '#1E293B' }}>
              第11条（本規約の変更）
            </h2>
            <ol style={{ paddingLeft: '1.5rem', color: '#64748B' }}>
              <li>
                当社は、次のいずれかに該当する場合、本規約を変更することができます。
                <ul style={{ paddingLeft: '1.5rem', marginTop: '0.5rem' }}>
                  <li>変更がユーザーの一般の利益に適合するとき</li>
                  <li>
                    変更が契約をした目的に反せず、変更の必要性、変更後の内容の相当性その他の変更に係る事情に照らして合理的なものであるとき
                  </li>
                </ul>
              </li>
              <li>
                当社は、前項による変更にあたり、変更後の本規約の内容及びその効力発生時期を、効力発生日の<strong>14日前まで</strong>に、本ウェブサイト上での掲示その他当社所定の方法により周知します。
              </li>
              <li>
                料金の変更その他ユーザーに重大な影響を及ぼす変更を行う場合、当社は、効力発生日の<strong>30日前まで</strong>に、ユーザーが登録したメールアドレス宛の通知によりこれを周知します。
              </li>
            </ol>
          </section>

          <section style={{ marginBottom: '2.5rem' }}>
            <h2 style={{ fontSize: '1.3rem', fontWeight: 700, marginBottom: '1rem', color: '#1E293B' }}>
              第12条（個人情報の取扱い）
            </h2>
            <ol style={{ paddingLeft: '1.5rem', color: '#64748B' }}>
              <li>
                当社によるユーザー自身の個人情報の取扱いについては、別途当社プライバシーポリシーの定めによるものとします。
              </li>
              <li>
                ユーザーが本サービスに登録する従業員等の個人情報について、<strong>当社はユーザーから取扱いの委託を受けた者としてこれを取り扱います。</strong>当社は、委託された個人情報を本サービスの提供に必要な範囲においてのみ利用し、当該範囲を超えて利用しません。
              </li>
              <li>
                当社は、前項の個人情報の取扱いの一部を第三者に再委託することがあります。再委託先はプライバシーポリシーに掲げるとおりとし、当社は再委託先に対し本条と同等の義務を課すものとします。
              </li>
              <li>
                ユーザーは、本サービスに従業員等の個人情報を登録するにあたり、当該本人に対する利用目的の通知・公表その他法令上必要な手続を自ら行うものとします。
              </li>
            </ol>
          </section>

          <section style={{ marginBottom: '2.5rem' }}>
            <h2 style={{ fontSize: '1.3rem', fontWeight: 700, marginBottom: '1rem', color: '#1E293B' }}>
              第13条（反社会的勢力の排除）
            </h2>
            <ol style={{ paddingLeft: '1.5rem', color: '#64748B' }}>
              <li>
                ユーザー及び当社は、自己が暴力団、暴力団員、暴力団準構成員、暴力団関係企業、総会屋、社会運動等標榜ゴロ、特殊知能暴力集団その他これらに準ずる者（以下「反社会的勢力」といいます。）に該当しないこと、及び反社会的勢力と社会的に非難されるべき関係を有しないことを表明し、保証します。
              </li>
              <li>
                ユーザー及び当社は、自らまたは第三者を利用して、暴力的な要求行為、法的な責任を超えた不当な要求行為、脅迫的な言動もしくは暴力を用いる行為、風説を流布し、偽計もしくは威力を用いて相手方の信用を毀損しまたは業務を妨害する行為を行わないことを確約します。
              </li>
              <li>
                ユーザーまたは当社が前2項に違反した場合、相手方は、<strong>催告その他何らの手続を要することなく、直ちに本契約を解除する</strong>ことができ、これにより相手方に生じた損害を賠償する責任を負いません。
              </li>
            </ol>
          </section>

          <section style={{ marginBottom: '2.5rem' }}>
            <h2 style={{ fontSize: '1.3rem', fontWeight: 700, marginBottom: '1rem', color: '#1E293B' }}>
              第14条（準拠法及び管轄裁判所）
            </h2>
            <ol style={{ paddingLeft: '1.5rem', color: '#64748B' }}>
              <li>本規約の準拠法は日本法とします。</li>
              <li>
                本規約に起因し、または関連する一切の紛争については、東京地方裁判所を第一審の専属的合意管轄裁判所とします。
              </li>
            </ol>
          </section>

          <p style={{ textAlign: 'right', color: '#999', marginTop: '3rem' }}>2025年11月1日 制定 ／ 2026年8月2日 改定</p>
        </div>
      </div>
    </div>
  );
};

export default TermsPage;
